import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, CircularProgress, Button, Box } from '@mui/material';

export const LoadingState = () => (
  <Stack direction="row" justifyContent="center" alignItems="center" mt={2}>
    <CircularProgress size={24} />
    <Typography variant="body2" ml={1}>
      Loading files...
    </Typography>
  </Stack>
);

export const ErrorState = ({ error }) => (
  <Typography variant="body2" color="error" mt={2}>
    Error loading files:
    {' '}
    {error?.data?.message || 'Unexpected error.'}
  </Typography>
);

ErrorState.propTypes = {
  error: PropTypes.shape({
    data: PropTypes.shape({
      message: PropTypes.string,
    }),
  }).isRequired,
};

export const EmptyState = ({ message }) => (
  <Typography variant="body2" color="text.secondary" mt={2}>
    {message}
  </Typography>
);

EmptyState.propTypes = {
  message: PropTypes.string.isRequired,
};

export const LoadMoreButton = ({ setPage, isLoading }) => (
  <Box textAlign="center">
    <Button onClick={() => setPage((prev) => prev + 1)} disabled={isLoading}>
      {isLoading ? 'Loading more...' : 'Load More'}
    </Button>
  </Box>
);

LoadMoreButton.propTypes = {
  setPage: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

LoadMoreButton.defaultProps = {
  isLoading: false,
};
